(function () {
  'use strict';

  if (customElements.get('qala-card-carousel')) return;

  class QalaCardCarousel extends HTMLElement {
    constructor() {
      super();
      this.index = 0;
      this.autoTimer = null;
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('.qala-card-carousel__img'));
      this.dots = Array.from(this.querySelectorAll('.qala-card-carousel__dot'));
      this.count = this.images.length;
      if (this.count < 2) return;

      // Delegate from the element itself rather than binding to the button
      // nodes directly — more resilient to any re-render/attachment timing.
      this.addEventListener('click', this.handleClick.bind(this));

      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (canHover) {
        this.addEventListener('mouseenter', this.startAuto.bind(this));
        this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      }
    }

    handleClick(e) {
      var prev = e.target.closest('.qala-card-carousel__arrow--prev');
      var next = e.target.closest('.qala-card-carousel__arrow--next');
      if (!prev && !next) return;
      e.preventDefault();
      e.stopPropagation();
      this.manualSelection = true;
      this.stopAuto();
      this.show(this.index + (next ? 1 : -1));
    }

    show(newIndex) {
      var i = ((newIndex % this.count) + this.count) % this.count;
      if (i === this.index) return;
      this.images[this.index].classList.remove('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.remove('is-active');
      this.index = i;
      this.images[this.index].classList.add('is-active');
      if (this.dots[this.index]) this.dots[this.index].classList.add('is-active');
    }

    handleMouseLeave() {
      this.stopAuto();
      if (!this.manualSelection) this.show(0);
    }

    startAuto() {
      if (this.autoTimer || this.manualSelection) return;
      var self = this;
      this.autoTimer = setInterval(function () {
        self.show(self.index + 1);
      }, 1100);
    }

    stopAuto() {
      if (this.autoTimer) {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }
    }

    disconnectedCallback() {
      this.stopAuto();
    }
  }

  customElements.define('qala-card-carousel', QalaCardCarousel);
})();
